/*
 * Author: Harper Yan
 * File Created: Monday, 25-04-14 04:23 pm
 * Last Modified: Monday, 25-04-14 04:24 pm, by Harper Yan
 */

import { graphql } from '@web/graphql';
import type { ErrorCodes, ErrorDetailResp } from '@web/utils';
import { getEnv } from '@web/utils';

const queryErrorCodes = graphql.gql`
  query DeCardErrorCodeAlls(
    $locale: I18NLocaleCode
    $status: PublicationStatus
    $filters: DeCardErrorCodeAllFiltersInput
    $sort: [String]
    $pagination: PaginationArg
  ) {
    deCardErrorCodeAlls(
      locale: $locale
      status: $status
      filters: $filters
      sort: $sort
      pagination: $pagination
    ) {
      action
      btn1
      btn2
      code
      header
      msg
      updatedAt
      publishedAt
      disabled
    }
  }
`;

export const fetchErrorCodes = async (locale = 'en', force = false) => {
  const env = getEnv();
  const isProd = env === 'prod';

  const targetKey = isProd ? 'publishedAt' : 'updatedAt';

  const { data } = await graphql.query<{
    deCardErrorCodeAlls?: (ErrorDetailResp & { __typename: string })[];
  }>(queryErrorCodes, {
    force,
    variables: {
      locale,
      sort: [`${targetKey}:desc`],
      pagination: {
        start: 0,
        limit: 9999,
      },
    },
  });

  const errorCodes = data.deCardErrorCodeAlls?.reduce((acc, cur) => {
    const { code, __typename: _, ...resCur } = cur;

    acc[code] = resCur;

    return acc;
  }, {} as ErrorCodes);

  return errorCodes ?? {};
};
